<template>
  <div class="table-wrapper">
    <div class="btn-all" v-if="btn">
      <slot name="btn" />
    </div>
    <slot
      :handleSelectionChange="handleSelectionChange"
      :tips="tips"
      :editor="editor"
      :handleCheckResult="handleCheckResult"
      :jumpRoute="jumpRoute"
      :changeAuthorizedStatus="changeAuthorizedStatus"
    />
    <Pagination
      ref="pagination"
      v-if="pagination.pageTotal >= 1"
      :currentPage="pagination.currentPage"
      :totalPage="pagination.pageTotal"
      :totalRecord="pagination.recordTotal"
      @handleNextPage="nextPage"
      @handlePrevPage="prevPage"
      @handleJumpPage="jumpPage"
      @handleChangePageSize="changePageSize"
    />
  </div>
</template>
<script>
import tableOpearting from 'mixins/tableOpearting/'

export default {
  name: 'TableComponent',
  mixins: [tableOpearting],
  props: {
    pagination: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routeName: {
      type: String
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    activeName: {
      type: String
    },
    type: {
      type: String
    }
  },
  methods: {
    /**
     * 提示
     * @param txt
     */
    tips(txt) {
      this.$alert(txt, '提示', {
        confirmButtonText: '确定',
        showClose: false,
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'warning',
        center: true
      })
    },
    /**
     * 编辑(绑定)
     * @param item
     * @param type
     */
    editor(item, type) {
      switch (this.routeName) {
        case 'credits':
          this.$emit('updateData', vm => {
            vm.operatorType = type
            vm.dialogVisible = true
          })
          break
        case 'bindApplets':
          this.$emit('updateData', vm => {
            vm.dialogVisible = true
            vm.popType = type
            vm.merchantId = item.id
            const data = {
              curpage: 1,
              binding_state: type
            }
            if (type === '2') data.merchant_id = item.id
            vm._getAppletsList(data)
          })
          break
        case 'goodsAuthorized':
          this.$router.push({
            name: 'authorized',
            query: {
              id: item.id,
              title: item.companyCnName,
              total: item.totalNum,
              code: item.code
            }
          })
          break
      }
    },
    /**
     * 跳转详情页
     * @param item
     */
    jumpRoute(item) {
      switch (this.routeName) {
        case 'companyCheck':
          this.$router.push({
            name: 'contractManagement',
            query: {
              id: item.id,
              title: item.companyCnName
            }
          })
          break
        case 'goodsCheck':
          this.$router.push({
            name: 'newProductRelease',
            query: {
              id: item.id,
              details: 1,
              title: item.cnName,
              merchantId: item.goodsMerchantId
            }
          })
          break
        case 'goodsAuthorized':
          this.$router.push({
            name: 'authorized',
            query: {
              id: item.id,
              details: 1,
              title: item.companyCnName,
              total: item.totalNum,
              code: item.code
            }
          })
          break
      }
    },
    /**
     * 调用父组件请求数据函数
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      let condition, data
      if (
        ['companyCheck', 'goodsCheck', 'authorized'].includes(this.routeName)
      ) {
        condition = vm.$refs.search[0]._returnSearchCondition()
      } else {
        condition = vm.$refs.search._returnSearchCondition()
      }
      data = {
        curpage: newValue,
        pageSize: size,
        ...condition
      }
      switch (this.routeName) {
        case 'companyCheck':
          vm._getMerchantList({
            ...data,
            audit_status: vm.activeName
          })
          break
        case 'bindApplets':
          vm._getBindList(data)
          break
        case 'goodsCheck':
          vm._getMerchantGoodsList({
            ...data,
            audit_status: vm.activeName
          })
          break
        case 'goodsAuthorized':
          vm._getGoodsAuthorizedList(data)
          break
        case 'authorized':
          vm._getGoodsAuthorized({
            ...data,
            search_model: vm.search_model[+vm.activeName - 1],
            merchant_id: this.$route.query.id
          })
          break
        case 'bindAppletsPop':
          vm.searchData(data)
          break
      }
    },
    /**
     * 授权状态选择
     * @param row
     */
    handleCheckResult(row) {
      this.$emit('updateData', vm => {
        vm.$refs.pop._changePopStatus(row, this)
      })
    },
    /**
     * 改变商品授权
     * @parm row
     */
    changeAuthorizedStatus(row) {
      const { status, sku, authorizedStock, specList, goodsId } = row
      const updatePage = () => {
        this.$emit('updateData', vm => {
          vm._getGoodsAuthorized({
            curpage: vm.pagination.currentPage,
            merchant_id: vm.$route.query.id,
            search_model: vm.search_model[+vm.activeName - 1]
          })
        })
      }
      let data = {
        merchant_id: this.$route.query.id,
        goods_id: goodsId,
        goods_sku: sku
      }
      if (status) {
        this.api.cancelGoodsAuthorized(data).then(() => {
          this.$notify({
            type: 'success',
            message: '取消成功~！🙂'
          })
          setTimeout(() => {
            updatePage()
          }, 300)
        })
      } else {
        data.spec_list = []
        specList.forEach(v => {
          const { startPrice, endPrice, salesNum, salesId } = v
          data.spec_list.push({
            sales_quantity: salesNum,
            sales_id: salesId,
            authorized_start_price: startPrice,
            authorized_end_price: endPrice
          })
        })
        this.api
          .addGoodsAuthorized(data)
          .then(() => {
            this.$notify({
              type: 'success',
              message: '授权成功~！🙂'
            })
            setTimeout(() => {
              updatePage()
            }, 300)
          })
          .catch(() => {
            row.status = false
          })
      }
    },
    /**
     * 修改授权商品库存
     * @param row
     */
    changeStock(row) {
      const { status, authorizedStock, sku, goodsId } = row
      if (status) {
        this.api
          .modifyAuthorizedStock({
            merchant_id: this.$route.query.id,
            goods_storage: authorizedStock,
            goods_sku: sku,
            goods_id: goodsId
          })
          .then(() => {
            this.$notify({
              type: 'success',
              message: '修改成功~！🙂'
            })
          })
      }
    },
    /**
     * 授权库存检测
     * @param row
     */
    exceptLimit(row) {
      if (row.authorizedStock > row.stock) {
        row.authorizedStock = row.stock
      }
    }
  }
}
</script>
